import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, ButtonType } from '@bettercomp/ui-components';
import { selectPolicyManagerNotifications } from 'redux/notifications/selectors';

import { showNotification } from '../common/function';
import { PATH } from '../common/constants';

export function usePolicyManagerCompleteEvent() {
  const router = useRouter();
  const notifications = useSelector(selectPolicyManagerNotifications);
  const [previousNotifications, setPreviousNotifications] = useState(notifications);

  const notificationBody = useMemo(() => (
    <div>
      The update has finished. View the details and history in the
      <Button
        type={ButtonType.Link}
        onClick={() => router.push(PATH.TABLE_PRICEJOB_MASS_POLICY_HISTORY)}
        size="small"
        data-testid="policyHistory"
      >
        Policy Manager
      </Button>
    </div>
  ), [router]);

  useEffect(() => {
    if (previousNotifications.length > notifications.length) {
      showNotification(notificationBody as any, 'Policy Run Complete', 'success');
    }

    setPreviousNotifications(notifications);
  }, [notifications, previousNotifications.length, notificationBody]);
}
